import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { CardProduct, Currencies, GetSkinsRes, Skin } from '@zeusm/business/core/entities';
import { buildBusinessApiUrl, buildBusinessApiUrlV2 } from '@zeusm/shared/core/helpers';

import { BusinessDictionariesApi } from './dictionaries-api.interface';

@Injectable()
export class BusinessDictionariesApiService implements BusinessDictionariesApi {
  readonly #http = inject(HttpClient);

  getCurrencies(): Observable<Currencies> {
    const api = buildBusinessApiUrl('settings/currencies');

    return this.#http.get<Currencies>(api).pipe(
      map(({ crypto, fiat }) => ({
        crypto: crypto.map(item => ({ ...item, id: item.currencyId })),
        fiat: fiat.map(item => ({ ...item, id: item.currencyId })),
      })),
    );
  }

  getSkins(): Observable<GetSkinsRes> {
    const api = buildBusinessApiUrlV2('skins');

    return this.#http.get<GetSkinsRes>(api).pipe(
      map(skins => {
        const cardSkins = skins.cardSkins ?? [];
        const walletSkins = skins.walletSkins ?? { card: [], crypto: [] };
        const withBypass = (skin: Skin): Skin => ({ ...skin, url: `${skin.url}?ngsw-bypass=true` });

        return {
          cardSkins: cardSkins.map(withBypass),
          walletSkins: {
            crypto: (walletSkins.crypto ?? []).map(withBypass),
            card: (walletSkins.card ?? []).map(withBypass),
          },
        } satisfies GetSkinsRes;
      }),
    );
  }

  getCardProducts(): Observable<CardProduct[]> {
    const api = buildBusinessApiUrlV2('card-products/');

    return this.#http.get<CardProduct[]>(api);
  }
}
